import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";
import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SPACING } from "../../constants/spacing";
import { useTheme } from "../../contexts/ThemeContext";

const LANGUAGES = [
  { code: "en", name: "English" },
  { code: "es", name: "Español" },
  { code: "fr", name: "Français" },
  { code: "pt-BR", name: "Português (Brasil)" },
  { code: "sw", name: "Kiswahili" },
  { code: "ht", name: "Kreyòl Ayisyen" },
  { code: "yo", name: "Yorùbá" },
  { code: "am", name: "አማርኛ" },
  { code: "de", name: "Deutsch" },
  { code: "it", name: "Italiano" },
];

const LanguageSettings = () => {
  const { t, i18n } = useTranslation("settings");
  const { colors } = useTheme();

  const currentLanguage = i18n.language || "en";

  const handleLanguageChange = async (event) => {
    const newLanguage = event.target.value;
    try {
      await i18n.changeLanguage(newLanguage);
      // Show success message (you can add a toast notification here)
      console.log(t("language.changeSuccess"));
    } catch (error) {
      console.error(t("language.changeError"), error);
    }
  };

  return (
    <Box>
      <Typography variant="h2" sx={{ mb: SPACING.sm }}>
        {t("language.title")}
      </Typography>

      <Typography
        variant="bodyMd"
        component="p"
        sx={{ color: "text.secondary", pb: SPACING.lg }}
      >
        {t("language.description")}
      </Typography>

      {/* Language Setting */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 3,
        }}
      >
        <Box>
          <Typography
            variant="bodyMd"
            sx={{ fontWeight: 500, mb: SPACING.xs, display: "block" }}
          >
            {t("language.selectLanguage")}
          </Typography>
        </Box>
        <Box sx={{ width: 250 }}>
          <FormControl fullWidth size="small">
            <Select value={currentLanguage} onChange={handleLanguageChange}>
              {LANGUAGES.map((language) => (
                <MenuItem key={language.code} value={language.code}>
                  {language.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>

      {/* Language Info */}
      <Box
        sx={{
          mt: SPACING.md,
          p: SPACING.md,
          borderRadius: 2,
          backgroundColor: (theme) =>
            theme.palette.mode === "dark"
              ? "rgba(59, 130, 246, 0.1)"
              : "rgba(59, 130, 246, 0.05)",
          border: "1px solid",
          borderColor: (theme) =>
            theme.palette.mode === "dark"
              ? "rgba(59, 130, 246, 0.2)"
              : "rgba(59, 130, 246, 0.15)",
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "flex-start", gap: SPACING.md }}
        >
          <Globe
            size={20}
            style={{ marginTop: "2px", flexShrink: 0 }}
            color={colors.primary}
          />
          <Box>
            <Typography sx={{ fontWeight: 500, mb: SPACING.md }}>
              {t("language.detectionTitle")}
            </Typography>
            <Typography sx={{ color: "text.secondary" }}>
              {t("language.detectionDescription")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LanguageSettings;
